import { createFileRoute } from '@tanstack/react-router';

import { DashboardPage } from '@dashboard';

export const Route = createFileRoute('/_app/dashboard')({
  component: DashboardPage,
  pendingComponent: DashboardPage.Pending,
  errorComponent: DashboardPage.Error,
});
